import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const RadioSquareSelect = ({
  fill = colors.silverSandAlt,
  size = 16,
  title = 'Select',
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 25.38 25.38">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M21.38,0H4A4,4,0,0,0,0,4V21.38a4,4,0,0,0,4,4H21.38a4,4,0,0,0,4-4V4A4,
4,0,0,0,21.38,0ZM18.63,8.28l-6.5,9.88a1.58,1.58,0,0,1-1.12.5A1.31,
1.31,0,0,1,9.88,18L7.26,14.41a1.16,1.16,0,0,1-.12-1.25,1.36,1.36,
0,0,1,1.25-.75A1.34,1.34,0,0,1,9.51,13L11,15l5.37-8.12a1.33,1.33,
0,0,1,1.13-.63A1.42,1.42,0,0,1,18.76,7,1.14,1.14,0,0,1,18.63,8.28Z
`}
        fill={fill}
      />
    </svg>
  );
};
